import { Camera, FileText, Image } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { usePickAndUploadDocument } from "web_myplann/Portfolio/Components/Redesign/Documents/usePickAndUploadDocument";
import { ActionsDrawerRedesign } from "web_myplann/Shared/Components/Redesign/ActionsDrawerRedesign";
import type { DrawerAction } from "web_myplann/Shared/Components/Redesign/ActionsDrawerRow";

type Props = {
	open: boolean;
	onClose: () => void;
};

export const AddDocumentDrawerRedesign: FC<Props> = ({ open, onClose }) => {
	const { t } = useResource();

	const { pickPhoto, pickGallery, pickFile, isPending } =
		usePickAndUploadDocument({ onUploaded: onClose });

	const R = Resources.Portfolio.List.AddDocumentDrawer;

	const actions: DrawerAction[] = [
		{
			key: "photo",
			label: t(R.Types.photo),
			icon: Camera,
			onClick: pickPhoto,
			disabled: isPending,
		},
		{
			key: "gallery",
			label: t(R.Types.gallery),
			icon: Image,
			onClick: pickGallery,
			disabled: isPending,
		},
		{
			key: "file",
			label: t(R.Types.file),
			icon: FileText,
			onClick: pickFile,
			disabled: isPending,
		},
	];

	return (
		<ActionsDrawerRedesign
			open={open}
			onClose={onClose}
			title={t(R.title)}
			actions={actions}
		/>
	);
};
